import * as _ from 'lodash-es';

export class ElementStylesPatch {

    private originalElementStyles: Partial<CSSStyleDeclaration>;

    constructor(
        private element: HTMLElement,
        private newStyles: Partial<CSSStyleDeclaration>
    ) {
        this.apply();
    }

    public revert(): void {
        this.setElementStyles(this.originalElementStyles);
    }

    private apply(): void {
        this.originalElementStyles = this.setElementStyles(this.newStyles);
    }

    private setElementStyles(styles: Partial<CSSStyleDeclaration>): Partial<CSSStyleDeclaration> {
        return _.transform(
            styles,
            (prevStyles, styleValue, styleProp) => {
                (prevStyles as Record<string, any>)[styleProp] =
                    this.element.style[styleProp as keyof CSSStyleDeclaration];

                (this.element.style as Record<string, any>)[styleProp] = styleValue;

                return prevStyles;
            },
            {} as Partial<CSSStyleDeclaration>
        );
    }

}
